import { render, staticRenderFns } from "./AudioDedup.vue?vue&type=template&id=c568d498&scoped=true"
import script from "./AudioDedup.vue?vue&type=script&lang=js"
export * from "./AudioDedup.vue?vue&type=script&lang=js"
import style0 from "./AudioDedup.vue?vue&type=style&index=0&id=c568d498&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c568d498",
  null
  
)

export default component.exports